export default __webpack_public_path__ + "static/icon-27-3-bb0b532787ed7b1bfca6ac827e6ed094.png";